export const getNotifs = (state) => {
  return state.notifs.notifList;
};
